import { useState } from "react";
import { Linechart } from "../charts"
import { SidePanel, SecurityBadge} from "../components"
import { openLink } from "../../classes/utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'

function Project({ project, tableColumns, colSpan }) {
  const [ projectMetricIsShown, setProjectMetricIsShown ] = useState(false);
  const [ selectedScan, setSelectedScan ] = useState("")
 
  const externalLinkClickHandler = (e, projectUUID) => {
    e.stopPropagation()
    openLink(`/projects/?pid=${projectUUID}&mode=eli`)
  }
  return (
    <>
      <tr className="cursor-pointer" onClick={(e) => setProjectMetricIsShown(!projectMetricIsShown)}>
        {tableColumns.map(({ accessorKey, columnName }, index) => {
          console.log({accessorKey})
          return (
            <td id={!index ? `project-${project[accessorKey]}`: ""} data-branch={project.projectBranch} key={columnName+"-data"} className={`td-${accessorKey} project-${project[accessorKey]} text-left ${projectMetricIsShown ? "project-metrics-shown": ""}`}>
                <div className={`flex items-center ${index && "justify-center"}`}>
                    {!index && <SecurityBadge securityScore={project.securityScore}></SecurityBadge>}
                    {
                      accessorKey=="projectUrl"? <div title={project.projectUrl} className="mr-2 project-url truncate"><div className="project-name project-front-name">{project.nameFront}</div><div className="project-name project-tail-name ">{project.nameTail}</div></div>
                      :
                      <span className={`truncate mr-2 text-center`}>{project[accessorKey]}</span>
                    }
                    {!index && <FontAwesomeIcon className="text-blue-500" icon={faArrowUpRightFromSquare} onClick={(e) => externalLinkClickHandler(e, project.projectUUID)}/>}
                </div>
            </td>
          );
        })}
      </tr>
      {projectMetricIsShown && (
        <tr id={`project-${project.projectUrl}-metrics`} className="project-metrics">
          <td colSpan={colSpan} className="h-72 w-full">
            { project.scans.length && 
              <div className="flex w-full">
                <div className="project-chart shadow-md w-3/5 mr-4">
                  <Linechart projectScans={project.scans} setSelectedScan={setSelectedScan}></Linechart>
                </div>
                <SidePanel project={project} projectScans={project.scans} projectUUID={project.projectUUID} selectedScan={selectedScan} setSelectedScan={setSelectedScan}></SidePanel>
              </div>
            }
          </td>
        </tr>
      )}
    </>
  );
}
export default Project;
